/**
 * utils/dateHelpers.js
 *
 * Funções utilitárias de data para o Dashboard.
 * Extraídas do useManagerDashboard para manter o hook limpo.
 */

import { toISODate } from "../../../../utils/date";

export function getMonthKey(dateISO) {
    return String(dateISO || "").slice(0, 7);
}

export function shiftMonth(dateISO, deltaMonths) {
    const base = new Date(`${dateISO}T12:00:00`);
    base.setMonth(base.getMonth() + deltaMonths);
    return toISODate(base);
}

function monthLabel(monthISO) {
    const [year, month] = monthISO.split("-");
    return new Date(Number(year), Number(month) - 1, 1)
        .toLocaleDateString("pt-BR", { month: "short" })
        .toUpperCase()
        .replace(".", "");
}

export function buildTrailingMonths(endDateISO) {
    const items = [];
    const endDate = new Date(`${endDateISO}T12:00:00`);

    for (let i = 11; i >= 0; i--) {
        const d = new Date(endDate.getFullYear(), endDate.getMonth() - i, 1);
        const monthISO = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
        items.push({
            monthISO,
            label: monthLabel(monthISO),
        });
    }

    return items;
}

export function buildYearMonths(yearNumber) {
    return Array.from({ length: 12 }, (_, idx) => {
        const monthISO = `${yearNumber}-${String(idx + 1).padStart(2, "0")}`;
        return {
            monthISO,
            label: ["JAN.", "FEV.", "MAR.", "ABR.", "MAI.", "JUN.", "JUL.", "AGO.", "SET.", "OUT.", "NOV.", "DEZ."][idx],
        };
    });
}
